import React from 'react';

import { link, routes } from '@aline/routes';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PartyDocuments } from 'src/components/parties';
import { usePartyParams } from 'src/helpers';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // Critical for DataGrid v7: allow flex container to shrink
    minHeight: 0,
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    // Use height 0 with flexGrow for proper DataGrid v7 sizing
    height: 0,
  },
}));

const { toRelativePath: toRelativePartyDetailPath } = createRelativeRouter(routes.PartyDetailIndex);

export function PartyRoutes(): JSX.Element {
  const { classes } = useStyles();
  const { partyId } = usePartyParams();
  const documentsTabValue = link.PartyDetailDocuments({ partyId });

  return (
    <div className={classes.container}>
      <Routes>
        <Route
          key={routes.PartyDetailDocuments}
          element={
            <div className={classes.panel}>
              <PartyDocuments />
            </div>
          }
          path={toRelativePartyDetailPath(routes.PartyDetailDocuments)}
        />
        <Route
          key={routes.PartyDetailDocumentPreview}
          element={
            <div className={classes.panel}>
              <PartyDocuments />
            </div>
          }
          path={toRelativePartyDetailPath(routes.PartyDetailDocumentPreview)}
        />
        <Route element={<Navigate replace to={documentsTabValue} />} path="/" />
      </Routes>
    </div>
  );
}
